import policyApi from "~/api/policy";

const getInitialPackageEditPageData = ({ getters, commit }) => {
  commit("SET_EDIT_PAGE_LOADED", false);
  policyApi.initializePackageData(getters.genericState?.policyId).then((response) => {
    commit("$_generic_insurance/SET_FORM", response.data?.form, { root: true });
    commit("SET_EDIT_PAGE_LOADED", true);
  });
};

export default {
  getInitialPackageEditPageData,
};
